/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityLockClosedIcon16Solid = forwardRef('SecurityLockClosedIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 0a4 4 0 0 0-4 4v1.05A2.5 2.5 0 0 0 2 7.5v4A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-4a2.5 2.5 0 0 0-2-2.45V4a4 4 0 0 0-4-4Zm2 5V4a2 2 0 1 0-4 0v1h4ZM8.75 9.75a1.25 1.25 0 1 0-1.5 0V11a.75.75 0 0 0 1.5 0V9.75Z" })));
});
